import { gsap, Power4 } from 'gsap';
import React, { useEffect } from 'react';
import styled, { css } from 'styled-components';

interface PopupProps {
  open: boolean;
  children?: JSX.Element;
  data?: any;
  popState?: String;
  dialogSize?: 'medium' | 'large' | 'small' | 'small02' | 'most-large' | 'full';
  type?: 'simple' | 'radius';
}

const PopupBox = styled.div<{ isRadius: boolean }>`
  position: relative;
  background-color: #fff;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  min-height: 12.75rem;
  height: 100%;

  ${props =>
    props.isRadius &&
    css`
      border-radius: 10px;
      padding: 3.75rem 3.75rem 2.25rem 3.75rem;
    `}
`;

const PopupWrap = styled.div`
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  outline: 0;
  overflow: hidden;
  z-index: 99999;
  text-align: center;
  &:before {
    content: '';
    display: inline-block;
    vertical-align: middle;
    height: 100%;
  }
`;

const PopupDialog = styled.div`
  display: inline-block;
  vertical-align: middle;
  margin: 0 auto;
  &.medium {
    width: 50rem;
    margin: 0 auto;
  }
  &.large {
    max-width: 71.25rem;
    margin: 0 auto;
  }
  &.small {
    max-width: 31.25rem;
    margin: 0 auto;
  }
  &.small02 {
    width: 26.25rem;
    margin: 0 auto;
  }

  &.most-large {
    padding: 0;
    width: auto;
    height: auto;
    margin: 0 auto;

    ${PopupBox} {
      padding: 0rem;
    }
  }

  &.full {
    overflow: hidden;
    position: fixed;
    top: 60px;
    top: 3.75rem;
    left: 60px;
    left: 3.75rem;
    bottom: 60px;
    bottom: 3.75rem;
    right: 60px;
    right: 3.75rem;
  }
`;

const BackGround = styled.div`
  display: none;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  background: #00000080;
`;

const Popup: React.FC<PopupProps> = ({ open, children, type = 'radius', dialogSize, popState }) => {
  useEffect(() => {
    if (open) {
      gsap.fromTo(
        `.popup-wrap${popState}`,
        {
          duration: 0.8,
          y: 100,
          opacity: 0,
          display: 'none',
          ease: Power4.easeOut
        },
        {
          duration: 0.8,
          y: 0,
          opacity: 1,
          display: 'block',
          ease: Power4.easeOut
        }
      );
      gsap.fromTo(
        `.dimm`,
        { duration: 0.8, opacity: 0, display: 'none', ease: Power4.easeOut },
        {
          duration: 0.8,
          opacity: 0.8,
          display: 'block',
          ease: Power4.easeOut
        }
      );
    } else {
      gsap.fromTo(
        `.popup-wrap${popState}`,
        {
          duration: 0.8,
          y: 0,
          opacity: 1,
          display: 'block',
          ease: Power4.easeOut
        },
        {
          duration: 0.8,
          y: 100,
          opacity: 0,
          display: 'none',
          ease: Power4.easeOut
        }
      );

      gsap.fromTo(
        `.dimm`,
        {
          duration: 0.8,
          opacity: 0.8,
          display: 'block',
          ease: Power4.easeOut
        },
        { duration: 0.8, opacity: 0, display: 'none', ease: Power4.easeOut }
      );
    }
  }, [open]);

  return (
    <>
      <PopupWrap className={`popup-wrap${popState}`}>
        <PopupDialog className={` ${dialogSize ? dialogSize : ''}`}>
          <PopupBox isRadius={type === 'radius'}>{children}</PopupBox>
        </PopupDialog>
      </PopupWrap>
      <BackGround className="dimm"></BackGround>
    </>
  );
};

export default Popup;
